<template>
    <div style="padding: 15px;height: 100vh">
        <a-card :title="render_type == 'add'?'สร้างข้อมูลเงินเดือน':'แก้ไขข้อมูลเงินเดือน'">
            <template #extra>
                <a-button style="display: flex" @click="$router.go(-1)" size="large">
                    <template #icon>
                        <span class="material-symbols-outlined">arrow_back_ios</span>
                    </template>
                    ย้อนกลับ
                </a-button>
            </template>
            <a-form :model="model_form" layout="vertical" :onFinish="submit_model_data">
                <a-collapse  class="add_salary" style="border-radius: 4px" v-model:activeKey="activeKey">
                    <a-collapse-panel key="1" :header="`รายได้`">
                        <template #extra>
                            <p v-if="requireCostFields" style="margin: 0; color: grey">
                                {{ `(ต้องระบุอีก ${requireCostFields})` }}
                            </p>
                        </template>
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required, place,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change,driver_type
                                    }, key in default_fields.Salary.inputs">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <div v-else-if="driver_type">
                                    <div v-if="model_form['employee_type_id']">
                                        <a-form-item :name="key == 'driver_id' ? model_form['employee_type_id'] == 2 ?'employee_name' : key : key" 
                                            :label="key == 'driver_id' ? model_form['employee_type_id'] == 2 ? 'ชื่อ-นามสกุลพนักงานบริษัท' : placeholder : placeholder" 
                                            :has-feedback="check_duplicate"
                                            :rules="check_duplicate? check_rule: (non_editable ? null : [{ required : key=='car_company_id' ? model_form['employee_type_id'] == 2? false : true : required, message: `โปรดระบุ ${placeholder}` }])">
                                            <div v-if="key === 'car_company_id'">
                                                <a-select id="car_company_id" v-model:value="model_form[key]"
                                                        :disabled="model_form['claim_status_id'] == 3 || model_form['employee_type_id'] == 2"
                                                        :placeholder="'เลือก'+placeholder"
                                                        @change="handleChange(null_on_change, on_change)">
                                                    <a-select-option
                                                        v-for="(company, index) in car_company"
                                                        :key="company.id"
                                                        :value="company.id"
                                                    >
                                                        {{ company.fullname }}
                                                    </a-select-option>
                                                </a-select>
                                            </div>
                                            <div v-else-if="key === 'driver_id'">
                                                <a-select
                                                    v-if="model_form['employee_type_id'] == 1"
                                                    show-search v-model:value="model_form[key]" 
                                                    @change="handleChange('driver' , on_change)" 
                                                    :options="driver_list_by_cc.map((e) => ({ value: e.id, label: e.firstname + ' ' + e.lastname }))"
                                                    :filter-option="filterOption"
                                                    :placeholder=" 'เลือก'+ placeholder"
                                                    :disabled="model_form['claim_status_id'] == 3">
                                                    <a-select-option v-for="option in driver_list_by_cc" :key="option.id" :value="option.id">
                                                        {{ option.firstname + ' ' + option.lastname }}
                                                    </a-select-option>
                                                </a-select>
                                                <a-select
                                                    v-if="model_form['employee_type_id'] == 2"
                                                    show-search v-model:value="model_form['employee_name']" 
                                                    @change="handleChange('employee_name' , on_change)" 
                                                    :options="driver_list_by_cc.map((e) => ({ value: e?.firstname ? e.firstname + ' ' + e.lastname : e?.fullname ?? null
                                                        , label: e?.firstname ? e.firstname + ' ' + e.lastname : e?.fullname ?? '' }))"
                                                    :filter-option="filterOption"
                                                    :placeholder=" 'เลือกชื่อ-นามสกุลพนักงานบริษัท'"
                                                    :disabled="model_form['claim_status_id'] == 3">
                                                    <a-select-option v-for="(option,index) in driver_list_by_cc" :key="index" :value="option.value">
                                                        {{ option.label + index}}
                                                    </a-select-option>
                                                </a-select>
                                            </div>
                                            <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                                :type="input_type"
                                                :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                            />
                                        </a-form-item>
                                    </div>
                                </div>
                                <a-form-item v-else :name="key" :label="placeholder " :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption"
                                        :disabled="model_form['claim_status_id'] == 3">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <div v-else-if="key === 'employee_type_id'">
                                        <a-select id="employee_type_id" v-model:value="model_form[key]"
                                                :key="employeeType.length" 
                                                :disabled="model_form['claim_status_id'] == 3"
                                                :placeholder="'เลือก'+placeholder"
                                                @change="handleChange('employee' , $event)">
                                            <a-select-option
                                                v-for="(em, index) in employeeType"
                                                :key="em.id"
                                                :value="em.id"
                                            >
                                                {{ em.name }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <div v-else-if="key === 'car_company_id'">
                                        <a-select id="car_company_id" v-model:value="model_form[key]"
                                                :key="car_company.length" 
                                                :disabled="model_form['claim_status_id'] == 3"
                                                :placeholder="'เลือก'+placeholder"
                                                @change="handleChange(null_on_change , on_change)">
                                            <a-select-option
                                                v-for="(company, index) in car_company"
                                                :key="company.id"
                                                :value="company.id"
                                            >
                                                {{ company.fullname }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <div v-else-if="key === 'driver_id'">
                                        <a-select
                                            show-search v-model:value="model_form[key]" 
                                            @change="handleChange('driver' , on_change)" 
                                            :options="driver_list_by_cc.map((e) => ({ value: e.id, label: e.firstname + ' ' + e.lastname }))"
                                            :filter-option="filterOption"
                                            :placeholder=" 'เลือก'+placeholder || ''"
                                            :disabled="model_form['claim_status_id'] == 3">
                                            <a-select-option v-for="option in driver_list_by_cc" :key="option.id" :value="option.id">
                                                {{ option.firstname + ' ' + option.lastname }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => {
                                                const isCarAvailable = driver.car_id === null || driver.id === model_form[key];
                                                const isCompanyMatch = model_form['company_3rd'] === 'บริษัทรถร่วม'
                                                    ? driver.company_3rd === 'บริษัทรถร่วม'
                                                    : true;
                                                const isCarCompanyMatch = model_form['car_company_id'] == driver.car_company_id;
                                                return isCarAvailable && isCompanyMatch && isCarCompanyMatch;
                                            })
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                        :disabled="model_form['claim_status_id'] == 3"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key] || model_form['claim_status_id'] == 3">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-checkbox-group v-else-if="key == 'company_3rd'" v-model:value="model_form[key]" style="margin-top: 12px;">
                                        <a-checkbox
                                            @change="handleChange('disable', $event, field)"
                                            v-model="model_form[key]"
                                            value="บริษัทรถร่วม"
                                            :disabled="model_form['claim_status_id'] == 3"
                                        >
                                            บริษัทรถร่วม
                                        </a-checkbox>
                                    </a-checkbox-group>
                                    <a-input v-else-if="key == 'sum_cost'" :value="cal_sum_cost" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable)"
                                    />
                                    <div v-else-if="input_type === 'textlabel'">
                                            <!-- <div style="padding:0 0 8px;line-height: 1.5715; white-space:initial;text-align:left;">{{ label }}</div> -->
                                            <a-input :placeholder="place" v-model:value="model_form[key]" :required="required" :disabled="model_form['claim_status_id'] == 3"/>
                                        </div>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <a-table
                                        v-else-if="input_type == 'table'"
                                        :columns="[
                                            {
                                                title: 'รายการ',
                                                dataIndex: 'name',
                                                key: 'name',
                                                width: 400,
                                            },
                                            {
                                                title: 'จำนวนรายการ',
                                                dataIndex: 'no_list',
                                                key: 'no_list',
                                                align:'center',
                                            },
                                            {
                                                title: 'จำนวนเงิน',
                                                dataIndex: 'amount',
                                                key: 'amount',
                                                align:'center',
                                            },
                                        ]"
                                        :dataSource="data_table_list"
                                        :pagination="false"
                                        :scroll="{ x: 'max-content',y: 300 }"
                                    >
                                        <template #bodyCell="{ column, record, index}" >
                                            <template v-if="column.key === 'name'">
                                                <a-form-item>
                                                    <a-input :disabled="true" v-model:value="record.name"
                                                    />
                                                </a-form-item>
                                            </template>
                                            <template v-if="column.key === 'no_list'">
                                                <a-form-item>
                                                    <a-input v-model:value="record.no_list"
                                                    type="number"
                                                    :disabled="model_form['claim_status_id'] == 3"
                                                    @change="handleChange('cost' , record)" 
                                                    />
                                                </a-form-item>
                                            </template>
                                            <template v-if="column.key === 'amount'">
                                                <a-form-item>
                                                    <a-input v-model:value="record.amount"
                                                    type="text"
                                                    :disabled="model_form['claim_status_id'] == 3"
                                                    @change="handleChange('cost' , record)"
                                                    />
                                                </a-form-item>
                                            </template>
                                            <template v-if="column.key === 'id'">
                                                <a-form-item>
                                                    <a-button danger type="text" @click="(data_table_list.splice(index, 1))">
                                                        <span class="material-symbols-outlined">delete</span>
                                                    </a-button>
                                                </a-form-item>
                                            </template>
                                        </template>
                                    </a-table>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        enable_button="false"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-range-picker
                                        v-else-if="input_type == 'daterange'"
                                        v-model:value="model_form[key]"
                                        format="DD/MM/YYYY"
                                        :placeholder="['Start Time', 'End Time']"
                                        style="width: 100%;"
                                        :disabled="model_form['claim_status_id'] == 3"
                                        @change="getTotalDate()"
                                    />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_file_car($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]?.[0]?.file || '#'" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[key]?.[0]?.file_name }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>
                    <a-collapse-panel key="2" :header="`รายการหัก`">
                        <template #extra>
                            <p v-if="requireCarFields" style="margin: 0; color: grey">
                                {{ `(ต้องระบุอีก ${requireCarFields})` }}
                            </p>
                        </template>
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required, place,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Salary.inputs2">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :label="placeholder " :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <a-select v-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <div v-else-if="key === 'car_company_id'">
                                        <a-select id="car_company_id" v-model:value="model_form[key]"
                                                :key="car_company.length" 
                                                :disabled="model_form['claim_status_id'] == 3"
                                                @change="handleChange(null_on_change , on_change)">
                                            <a-select-option
                                                v-for="(company, index) in car_company"
                                                :key="company.id"
                                                :value="company.id"
                                            >
                                                {{ company.fullname }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => {
                                                const isCarAvailable = driver.car_id === null || driver.id === model_form[key];
                                                const isCompanyMatch = model_form['company_3rd'] === 'บริษัทรถร่วม'
                                                    ? driver.company_3rd === 'บริษัทรถร่วม'
                                                    : true;
                                                const isCarCompanyMatch = model_form['car_company_id'] == driver.car_company_id;
                                                return isCarAvailable && isCompanyMatch && isCarCompanyMatch;
                                            })
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                        :disabled="model_form['claim_status_id'] == 3"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key]|| model_form['claim_status_id'] == 3">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-checkbox-group v-else-if="key == 'company_3rd'" v-model:value="model_form[key]" style="margin-top: 12px;">
                                        <a-checkbox
                                            @change="handleChange('disable', $event, field)"
                                            v-model="model_form[key]"
                                            value="บริษัทรถร่วม"
                                            :disabled="model_form['claim_status_id'] == 3"
                                        >
                                            บริษัทรถร่วม
                                        </a-checkbox>
                                    </a-checkbox-group>
                                    <a-input v-else-if="key == 'sum_price'" :value="cal_sum_price" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3)"
                                    />
                                    <div v-else-if="key === 'insurance_price' && businessTypeId == 4">
                                        <a-input v-model:value="model_form.insurance_price" 
                                            :placeholder="placeholder"
                                            :type="input_type"
                                            :disabled="true"
                                        />
                                    </div>
                                    <div v-else-if="input_type === 'textlabel'">
                                            <!-- <div style="padding:0 0 8px;line-height: 1.5715; white-space:initial;text-align:left;">{{ label }}</div> -->
                                            <a-input :placeholder="place" v-model:value="model_form[key]" :required="required" />
                                        </div>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :drawer_button_text="drawer_button_text"
                                        :drawer_button_text_edit="drawer_button_text_edit"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_file_car($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]?.[0]?.file || '#'" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[key]?.[0]?.file_name }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>
                    <a-collapse-panel key="3" :header="`สรุปยอดเงินเดือน`">
                        <template #extra>
                            <p v-if="requireCarFields" style="margin: 0; color: grey">
                                {{ `(ต้องระบุอีก ${requireCarFields})` }}
                            </p>
                        </template>
                        <a-row>
                            <a-col style="margin: 1rem" :span="col_span" v-for="
                                    {
                                        col_span, non_editable, input_type, search_select, modelname, label_key, label, placeholder, required, place,
                                        target_key, target_modelname, drawer_title, label_function, table_columns, drawer_fields, drawer_button_text, drawer_button_text_edit, parent, null_on_change, check_duplicate, check_rule,
                                        on_change
                                    }, key in default_fields.Salary.inputs3">
                                <div v-if="input_type== 'label'">{{ label }}</div>
                                <a-form-item v-else :name="key" :has-feedback="check_duplicate"
                                    :rules="check_duplicate? check_rule: (non_editable ? null : [{ required, message: `โปรดระบุ ${placeholder}` }])">
                                    <template v-if="key === 'total_price'" #label>
                                        <div style="display: flex; align-items: end; gap:25px;">
                                            <span>{{ placeholder }}</span>
                                            <a-button type="primary" :disabled="false" @click="priceCar()">
                                                คำนวณ
                                            </a-button>
                                        </div>
                                    </template>

                                    <template v-else #label>
                                        {{ placeholder }}
                                    </template>
                                    <a-select v-if="key === 'client_id'" 
                                        show-search v-model:value="model_form[key]" 
                                        @change="handleChange(null_on_change , on_change)" 
                                        :options="selectables['Client'].map((e) => ({ value: e.id, label: e.fullname }))"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="option in selectables['Client']" :key="option.id" :value="option.id">
                                            {{ option.fullname }}
                                        </a-select-option>
                                    </a-select>
                                    <div v-else-if="key === 'car_company_id'">
                                        <a-select id="car_company_id" v-model:value="model_form[key]"
                                                :key="car_company.length" 
                                                :disabled="disabletest"
                                                @change="handleChange(null_on_change , on_change)">
                                            <a-select-option
                                                v-for="(company, index) in car_company"
                                                :key="company.id"
                                                :value="company.id"
                                            >
                                                {{ company.fullname }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                    <a-select
                                        v-else-if="input_type == 'select' && search_select && selectables[modelname]"
                                        v-model:value="model_form[key]"
                                        show-search
                                        :placeholder="placeholder"
                                        :options="modelname == 'Driver' ? selectables[modelname]
                                            .filter(driver => {
                                                const isCarAvailable = driver.car_id === null || driver.id === model_form[key];
                                                const isCompanyMatch = model_form['company_3rd'] === 'บริษัทรถร่วม'
                                                    ? driver.company_3rd === 'บริษัทรถร่วม'
                                                    : true;
                                                const isCarCompanyMatch = model_form['car_company_id'] == driver.car_company_id;
                                                return isCarAvailable && isCompanyMatch && isCarCompanyMatch;
                                            })
                                            .map(e => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] })) :
                                            selectables[modelname].map((e) => ({ value: e.id, label: label_function ? label_function(e) : e[label_key] }))"
                                        :filter-option="filterOption"
                                        @change="handleChange(null_on_change)"
                                    ></a-select>
                                    <a-select v-else-if="input_type == 'sub_select'"
                                        v-model:value="model_form[key]" :disabled="!model_form[parent.key] || model_form['claim_status_id'] == 3">
                                        <a-select-option 
                                            v-for="{id,name} in selectables[modelname]?.filter(e => e[parent.key] == model_form[parent.key])"
                                            :value="id" 
                                            selected
                                        >
                                            {{ name }}
                                        </a-select-option>
                                    </a-select>
                                    <a-checkbox-group v-else-if="key == 'company_3rd'" v-model:value="model_form[key]" style="margin-top: 12px;">
                                        <a-checkbox
                                            @change="handleChange('disable', $event, field)"
                                            v-model="model_form[key]"
                                            value="บริษัทรถร่วม"
                                        >
                                            บริษัทรถร่วม
                                        </a-checkbox>
                                    </a-checkbox-group>
                                    <div v-else-if="input_type === 'textlabel'">
                                            <!-- <div style="padding:0 0 8px;line-height: 1.5715; white-space:initial;text-align:left;">{{ label }}</div> -->
                                            <a-input :placeholder="place" v-model:value="model_form[key]" :required="required" />
                                        </div>
                                    <a-divider v-else-if="input_type == 'divider'" orientation="left">{{ label
                                    }}</a-divider>
                                    <a-divider v-else-if="input_type == 'sub-divider'" orientation="left">
                                        <h5>{{ label }}</h5>
                                    </a-divider>
                                    <TableCreateDrawer v-else-if="input_type == 'table'" :divider="drawer_title"
                                        :table_columns="table_columns" :target_object="model_form"
                                        :target_key="target_key" :drawer_title="drawer_title"
                                        :drawer_fields="drawer_fields.inputs"
                                        :target_modelname="target_modelname" />
                                    <a-date-picker v-else-if="input_type == 'date'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-date-picker v-else-if="input_type == 'datetime'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :show-time="{ format: 'HH:mm' }"
                                        format="DD/MM/YYYY HH:mm"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-date-picker v-else-if="input_type == 'month'" v-model:value="model_form[key]"
                                        :placeholder="placeholder" style="display: flex;"
                                        picker="month"
                                        format="MMMM"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <a-switch v-else-if="input_type == 'switch'" 
                                        v-model:checked="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" /> 
                                    <a-textarea v-else-if="input_type == 'textarea'" v-model:value="model_form[key]"
                                        :placeholder="placeholder"
                                        :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3" />
                                    <div v-else-if="input_type == 'photos'" class="clearfix">
                                        <a-upload v-model:file-list="model_form[target_key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" method="GET"
                                            @remove="remove_uploaded_file($event)"
                                            list-type="picture-card">
                                            <div v-if="model_form[target_key]?.length < 5"
                                                style="height: 104px; width: 104px; padding: 2rem">
                                                <span style="font-size: 20px"
                                                    class="material-symbols-outlined">add</span>
                                                <div style="margin-top: 8px">Upload</div>
                                            </div>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type == 'photo'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList"
                                            :show-upload-list="false"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, key)" 
                                            method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                        >
                                            <div v-if="model_form[key]" class="upload-container">
                                                <img :src="model_form[key]" class="uploaded-image" alt="avatar" @click="showPreview(model_form[key])"/>
                                                <div class="icon-container">
                                                    <span
                                                        class="material-symbols-outlined preview-icon"
                                                        @click="handleIconClick('preview', model_form[key], $event)"
                                                    >
                                                        visibility
                                                    </span>
                                                    <a :href="model_form[key]" download @click.stop>
                                                        <span class="material-symbols-outlined download-icon"
                                                    >
                                                            download
                                                        </span>
                                                    </a>
                                                    <span
                                                        class="material-symbols-outlined delete-icon"
                                                        @click="handleIconClick('delete', key, $event)"
                                                    >
                                                        delete
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                        </a-upload>
                                        <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false" class="custom-modal" style="background-color: none !important" >
                                            <img :src="previewImage" alt="Preview" style="width: 100%;" />
                                        </a-modal>
                                    </div>
                                    <!-- upload_file -->
                                    <div v-else-if="input_type == 'file'" style="display: flex; flex-direction: column; align-items: center; gap:1rem">
                                        <div>{{ label }}</div>
                                        <a-upload 
                                            v-model:file-list="fileList" 
                                            v-if="!model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            :show-upload-list="false"
                                            @change="upload_file_car($event, key)"
                                        >
                                            <img v-if="model_form[key]" :src="model_form[key]"
                                                style="width: 100%; height: 100px;"
                                                alt="avatar"
                                            />
                                            <div style="display: flex; flex-direction: column; align-items: center;">
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined" 
                                                        style="font-size: 5rem;">upload_file</span>
                                                </p>
                                                อัพโหลดไฟล์
                                            </div>
                                        </a-upload>
                                        <a :href="model_form[key]?.[0]?.file || '#'" v-else="model_form[key]"
                                            target="_blank" rel="doc"
                                        >
                                            {{ model_form[key]?.[0]?.file_name }}
                                        </a>
                                        <a-button danger type="text" @click="(model_form[key] = '')" style="padding: 0; height: 18px;"
                                            v-if="model_form[key]">
                                            <span class="material-symbols-outlined">close</span>
                                        </a-button>
                                    </div>
                                    <div  v-else-if="input_type == 'table_files'" >
                                        <a-table
                                            :columns="[
                                                {
                                                    title: 'ชื่อเอกสาร',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    width: 400,
                                                },
                                                {
                                                    title: 'ไฟล์เอกสาร',
                                                    dataIndex: 'file',
                                                    key: 'file',
                                                },
                                                {
                                                    title: 'ลบ',
                                                    dataIndex: 'id',
                                                    key: 'id',
                                                    width: 100,
                                                    align: 'center',
                                                }
                                            ]"
                                            :dataSource="data_raw_files"
                                            :pagination="false"
                                            :scroll="{ y: 240 }"
                                        >
                                            <template #bodyCell="{ column, record, index}" >
                                                <template v-if="column.key === 'name'">
                                                    <a-form-item>
                                                        <a-input v-model:value="record.name"
                                                        />
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'file'">
                                                    <a-form-item>
                                                    <a :href="record.file" target="_blank" rel="doc">{{ record.file_name }}</a>
                                                    </a-form-item>
                                                </template>
                                                <template v-if="column.key === 'id'">
                                                    <a-form-item>
                                                        <a-button danger type="text" @click="(data_raw_files.splice(index, 1))">
                                                            <span class="material-symbols-outlined">delete</span>
                                                        </a-button>
                                                    </a-form-item>
                                                </template>
                                            </template>
                                        </a-table>
                                        <a-upload v-model:file-list="model_form[key]"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            method="GET"
                                            @change="upload_file_multiple($event, key)"
                                            :show-upload-list="false"
                                            >
                                            <a-button style="margin-top: 10px;">
                                                <span class="material-symbols-outlined">add</span>
                                                เพิ่มไฟล์
                                            </a-button>
                                        </a-upload>
                                    </div>
                                    <div v-else-if="input_type== 'password'">
                                        <a-input-password v-if="action_type== 'create'" v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3"
                                            autoComplete="new-password"
                                        />
                                        <a-input-password v-else v-model:value="model_form[key]" 
                                            :placeholder="placeholder" 
                                            :type="input_type"
                                            :disabled="action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3"
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    
                                    <a-input v-else v-model:value="model_form[key]" :placeholder="placeholder"
                                        :type="input_type"
                                        :disabled="key === 'client_no' ? true : (action_type == 'create' ? false : non_editable || model_form['claim_status_id'] == 3)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse-panel>
                </a-collapse>
                <a-row justify="end" style="margin-top: 14px;">
                    <a-form-item>
                        <a-button type="primary" size="large" html-type="submit" :disabled="model_form['claim_status_id'] === 3">
                            <template #icon>
                                <span style="font-size: 20px; color: white" class="material-symbols-outlined">Edit_Square</span>
                            </template>
                            บันทึกข้อมูล
                        </a-button>
                    </a-form-item>
                </a-row>
            </a-form>
        </a-card>
    </div>
</template>

<script>
import Utility from '../../utility'
import Swal from 'sweetalert2'
import SystemService from '../../api/SystemService'
import UserService from '../../api/UserService';
import CompanyService from '../../api/CompanyService';
import salary_fields from '../../field_config/salary_fields';
import TableCreateDrawer from '@/components/table_create_drawer.vue'
import DriverService from '../../api/DriverService';
import SalaryService from '../../api/SalaryService';
import dayjs from 'dayjs';
import { em } from '@fullcalendar/core/internal-common';
export default {
    components: { 
        TableCreateDrawer, 
      },  
    name: 'salaryAdminDetail',
    computed: {
        render_type() {
            return this.$route.params.type
        },
        driver_list_by_cc(){
            if(this.model_form['employee_type_id'] == 1 && this.model_form['car_company_id']){
                return this.driver_list.filter((item)=>item.car_company_id == this.model_form['car_company_id']);
            }else if(this.model_form['employee_type_id'] == 1){
                return this.driver_list;
            }else if(this.model_form['employee_type_id'] == 2){
                return this.pagination?.data
            }else{
                return this.driver_list;
            }
        },
        requireCostFields() {
            const fieldsToCheck = ['month_period', 'purchase_datetime'];
            return fieldsToCheck.filter(field => !this.model_form[field]).length;
        },
        cal_sum_cost(){
            let sum = 0
            for (const key in this.default_fields.Salary.inputs) {
                if (key === 'divider_1' || key === 'divider_2' 
                || key === 'sum_cost' || key === 'month_period' 
                || key === 'purchase_datetime' || key === 'car_company_id'
                || key === 'driver_id' || key === 'driver_no'
                || key === 'employee_type_id') continue

                const value = parseFloat(this.model_form[key])
                if (!isNaN(value)) {
                sum += value
                }
            }

            for (const {amount,price} of this.thaiToEngMap) {
                const amounts = parseFloat(this.model_form[amount])
                const values = parseFloat(this.model_form[price])
                if (!isNaN(values) && !isNaN(amounts)) {
                    sum += (amounts*values)
                }
            }

            // กำหนดค่าลงใน model_form หรือจะ return ก็ได้
            this.model_form.sum_cost = sum
            return sum
        },
        cal_sum_price(){
            let sum = 0
            for (const key in this.default_fields.Salary.inputs2) {
                if (key === 'divider_3' || key === 'sum_price') continue

                const value = parseFloat(this.model_form[key])
                if (!isNaN(value)) {
                sum += value
                }
            }

            // กำหนดค่าลงใน model_form หรือจะ return ก็ได้
            this.model_form.sum_price = sum
            return sum
        },
    },
    data() {
        return {
            business: false,
            businessTypeId: null,
            editable: Utility.get_permission_editable_with_key('gas_station'),
            img_placeholder: require('@/assets/images/place-holder/placeholder.jpg'),
            show_table_list: [],
            fileList: [],
            title: 'จัดการปั๊มน้ำมัน',
            button_title: 'เพิ่มปั๊มน้ำมัน',
            input: 'ชื่อปั๊มน้ำมัน',
            search_input: null,
            activeKey: [],
            model_form: {},
            default_fields: {
                Salary: {
                    ...salary_fields,
                    inputs: {
                        ...salary_fields.inputs || {},
                    }
                },
            },
            car_company: [],
            driver_list: [],
            editId: null,
            allEditable: true,
            columns: [
                {
                    title: 'ชื่อปั๊มน้ำมัน',
                    dataIndex: 'name',
                    key: 'name',
                    sorter: true,
                    width: 200,
                    align: 'center',
                }, {
                    title: 'ผู้ติดต่อ',
                    dataIndex: 'contact_name',
                    key: 'contact_name',
                    sorter: true,
                    width: 200,
                    align: 'center',
                }, {
                    title: 'เบอร์โทร',
                    dataIndex: 'phone_no',
                    key: 'phone_no',
                    width: 125,
                    align: 'center',
                }, {
                    title: 'ที่อยู่',
                    dataIndex: 'address',
                    key: 'address',
                    width: 120,
                    align: 'center',
                }, {
                    title: 'ตัวเลือก',
                    dataIndex: 'id',
                    key: 'id',
                    width: 100,
                    fixed: 'right',
                    align: 'center',
                }
            ],
            detail: {
                id: null,
                name: null,
                contact_name: null,
                phone_no: null,
                address: null,
                photo: null,
                company_id: null
            },
            employeeType: [
                {id:1,name:"พนักงานขับรถ"},
                {id:2,name:"พนักงานบริษัท"}
            ],
            pagination: {
                page: 1,
                perPage: 10,
            },
            data_table_list:[
                { name: 'ค่าเที่ยวพิเศษ', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (20)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (25)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (30)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (35)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (40)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (50)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (60)', no_list: null, amount: null },
                { name: 'ค่าเที่ยว (80)', no_list: null, amount: null },
                { name: 'ค่าเที่ยววันหยุด (70)', no_list: null, amount: null },
                { name: 'ค่ารายการ (200)', no_list: null, amount: null },
                { name: 'ค่ารายการ (300)', no_list: null, amount: null },
                { name: 'ค่ารายการวันอาทิตย์', no_list: null, amount: null },
                { name: 'ค่ารายการต่างจังหวัด', no_list: null, amount: null },
                { name: 'ค่ากลางคืน', no_list: null, amount: null },
                { name: 'ค่าเดินทาง', no_list: null, amount: null },
                { name: 'OT', no_list: null, amount: null },
                { name: 'ค่าจอดปลายทาง', no_list: null, amount: null },
                { name: 'ค่าที่จอดรถ', no_list: null, amount: null },
            ],
            thaiToEngMap : [
                { name: 'ค่าเที่ยวพิเศษ', amount: 'special_trip_amount', price: 'special_trip_price' },
                { name: 'ค่าเที่ยว (20)', amount: 'amount_1', price: 'price_1' },
                { name: 'ค่าเที่ยว (25)', amount: 'amount_2', price: 'price_2' },
                { name: 'ค่าเที่ยว (30)', amount: 'amount_3', price: 'price_3' },
                { name: 'ค่าเที่ยว (35)', amount: 'amount_4', price: 'price_4' },
                { name: 'ค่าเที่ยว (40)', amount: 'amount_5', price: 'price_5' },
                { name: 'ค่าเที่ยว (50)', amount: 'amount_6', price: 'price_6' },
                { name: 'ค่าเที่ยว (60)', amount: 'amount_7', price: 'price_7' },
                { name: 'ค่าเที่ยว (80)', amount: 'amount_8', price: 'price_8' },
                { name: 'ค่าเที่ยววันหยุด (70)', amount: 'rest_amount', price: 'rest_price' },
                { name: 'ค่ารายการ (200)', amount: 'menu_amount', price: 'menu_price' },
                { name: 'ค่ารายการ (300)', amount: 'menu_amount_2', price: 'menu_price_2' },
                { name: 'ค่ารายการวันอาทิตย์', amount: 'sunday_amount', price: 'sunday_price' },
                { name: 'ค่ารายการต่างจังหวัด', amount: 'province_amount', price: 'province_price' },
                { name: 'ค่ากลางคืน', amount: 'night_amount', price: 'night_price' },
                { name: 'ค่าเดินทาง', amount: 'travel_amount', price: 'travel_price' },
                { name: 'OT', amount: 'ot_amount', price: 'ot_price' },
                { name: 'ค่าจอดปลายทาง', amount: 'destination_amount', price: 'destination_price' },
                { name: 'ค่าที่จอดรถ', amount: 'parking_amount', price: 'parking_price' },
            ],
        }
    },
    methods: {
        clear_model_data() {
            this.$emit('apply_model_data', {})
            this.$router.go(-1)
        },
        async get_company() {
			const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id);
            const data = await CompanyService.getAllManageUsers(this.pagination.page, this.pagination.perPage);
            this.pagination = data;
            this.businessTypeId = businessType.data;
            if ( businessType.data === 2)
            {
                this.business = true
            }
        },
        priceCar(){
            this.model_form['total_price'] = parseFloat(this.model_form['sum_cost']||0) - parseFloat(this.model_form['sum_price']||0);
        },
        async handleChange(type, event,action) {
            if(type == 'employee' && event == 1){
                this.model_form['car_company_id'] = null
                this.model_form['employee_name'] = null
            }else if(type=='employee'){
                this.model_form['car_company_id'] = this.car_company[0].id
                this.model_form['driver_id'] = null
            }
            if(type == "driver"){
                let driverFound = this.driver_list.find((item)=>item.id == this.model_form['driver_id']);
                this.model_form['driver_no'] = driverFound?.driver_no;
                this.model_form['driver_salary'] = driverFound?.salary;
                this.model_form['set_leader'] = driverFound?.set_leader;
                this.model_form['insurance_price'] = Math.round(driverFound?.salary * 0.05 * 100) / 100
            }
            if(type == "employee_name"){
                let employeeFound = this.pagination?.data?.find((item)=>(item?.fullname == this.model_form['employee_name']) 
                    || (item?.firstname + " " + item?.lastname == this.model_form['employee_name']));
                this.model_form['driver_no'] = employeeFound?.employee_no;
                this.model_form['driver_salary'] = Number(employeeFound?.salaly);
                this.model_form['set_leader'] = employeeFound?.set_leader || 0;
                this.model_form['insurance_price'] = Number(employeeFound?.insurance_price) || 0;
            }
            if(type == 'cost'){
                let nameRecord = this.thaiToEngMap.find((item)=>item.name == event?.name);
                this.model_form[nameRecord.amount] = event?.no_list;
                this.model_form[nameRecord.price] = event?.amount; 
            }

        },
        async submit_model_data() {
            this.priceCar();
            if(this.model_form['purchase_datetime']){
                this.model_form['purchase_end_datetime'] = this.model_form['purchase_datetime'][1]; 
                this.model_form['purchase_datetime'] = this.model_form['purchase_datetime'][0];
            }
            if(this.requireCostFields){
                this.activeKey = 1;
                this.$nextTick(() => {
                    const field = document.querySelector('#requiredFieldId'); 
                    if (field) {
                        field.focus();
                    }
                });
                return
            }
            // delete this.model_form['driver_salary'];
            // delete this.model_form['set_leader'];
            const data = JSON.parse(JSON.stringify(this.model_form));
            try {
                Swal.fire({
                    title: 'กรุณารอสักครู่',
                    text: 'กำลังบันทึกข้อมูล',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading();
                    }
                });
                if (this.render_type === 'add') {
                    let res = await SalaryService.createSalary({ data: [data] });
                } else {
                    let res = await SalaryService.updateSalary({ data: [data] }, this.model_form.id);
                }
                Swal.close();
                Swal.fire({
                    title: 'บันทึกข้อมูลสำเร็จ',
                    icon: 'success',
                    timer: 2500,
                    timerProgressBar: false,
                    showConfirmButton: false,
                });
            } catch (error) {
                Swal.close();
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถบันทึกข้อมูลได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง',
                });
                console.log(error);
            } finally {
                this.clear_model_data();
            }
        },
        filterOption (input, option) {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        async getTotalDate() {
            const start = this.model_form['purchase_datetime'][0];
            const end = this.model_form['purchase_datetime'][1];
            const totalDays = end.diff(start, 'days');
        },
        to_create() {
            this.detail = {
                id: null,
                name: null,
                contact_name: null,
                phone_no: null,
                address: null,
                photo: null,
                company_id: null
            }
        },
        async init_data(){
            this.car_company = await SystemService.get_all("CarCompany")
            this.driver_list = await DriverService.getDriverByCompany();
            if(this.render_type != 'add'){
                let fetchSalary = await SalaryService.getSalaryById(this.render_type);
                fetchSalary[0].purchase_datetime = [dayjs(fetchSalary[0].purchase_datetime),dayjs(fetchSalary[0].purchase_end_datetime)]
                this.model_form = fetchSalary[0];
                if(this.model_form?.employee_name){
                    this.model_form['employee_type_id'] = 2;
                }else{
                    this.model_form['employee_type_id'] = 1;
                }
                // let driverFound = this.driver_list.find((item)=>item.id == this.model_form['driver_id']);
                // this.model_form['driver_no'] = driverFound?.driver_no;
                // this.model_form['driver_salary'] = driverFound?.salary;
                // this.model_form['set_leader'] = driverFound?.set_leader;
                this.thaiToEngMap.forEach((item,index)=>{
                    this.data_table_list[index].no_list = this.model_form[item.amount]
                    this.data_table_list[index].amount = this.model_form[item.price]
                });
            }
        },
        async get_gas_station_detail(){
            this.detail = await SystemService.get_id('GasStation', this.$route.params.id)
        },
        filtered_list(array) {
            return array.filter(({ name }) => {
                if(this.search_input){
                    return name.toLowerCase().includes(this.search_input.toLowerCase())
                } else {
                    return true
                }
            })
        },
        onResetData(){
             this.detail =  {
                id: null,
                name: null,
                contact_name: null,
                phone_no: null,
                address: null,
                photo: null,
                company_id: null
            }
        },
        onRefresh() {
             this.init_stations()
        },
    },
    async mounted() {
        await this.get_company();
        await this.init_data();
    }
}
</script>
<style scoped>
.add_salary {
    background-color: #e5e4e2;
}
</style>
<style>
.ant-table-thead .center-header {
  text-align: center; /* จัดตำแหน่งหัวคอลัมน์ให้อยู่ตรงกลาง */
}
</style>